import { Input, Select } from "antd";
import Question from "../Question/Question";

const ShortAnswer = ({
  index,
  id,
  noNumber,
  disabled,
  label,
  description,
  onChange,
  field_type,
  noDetail,
  reOrder,
  onRemove,
  duplicateQuestion,
  formContainer,
  question_number,
}) => {
  return (
    <Question
      formContainer={formContainer}
      question_number={question_number}
      disabled={disabled}
      duplicateQuestion={duplicateQuestion}
      onChange={onChange}
      description={description}
      label={label}
      index={index}
      noDetail={noDetail}
      id={id}
      // type={noNumber ? `${noNumber} - پاسخ نوشتاری` : "پاسخ نوشتاری"}
      type={"پاسخ نوشتاری"}
      reOrder={reOrder}
      onRemove={onRemove}
    >
      {/* {!noDetail && ( */}
      {!noDetail && (
        <Select
          onChange={(e) => {
            onChange("field_type", e);
          }}
          defaultValue={field_type}
          style={{ width: "100%" }}
          placeholder="نوع سوال"
        >
          <Select.Option value="text">تشریحی کوتاه</Select.Option>
          <Select.Option value="paragraph">تشریحی بلند</Select.Option>
          <Select.Option value="number">عدد</Select.Option>
        </Select>
      )}
    </Question>
  );
};
export default ShortAnswer;
